import { render, staticRenderFns } from "./AddMerchantSettings.vue?vue&type=template&id=21a8c205&scoped=true"
import script from "./AddMerchantSettings.vue?vue&type=script&lang=js"
export * from "./AddMerchantSettings.vue?vue&type=script&lang=js"
import style0 from "./AddMerchantSettings.vue?vue&type=style&index=0&id=21a8c205&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a8c205",
  null
  
)

export default component.exports